<template>
  <div class="home-page">
    <HeroSection />
    <ProductsSection />
    <StatsSection />
    <AboutSection />
    <WhyUsSection />
    <CTASection />
  </div>
</template>

<script>
import HeroSection from './HeroSection.vue'
import ProductsSection from './ProductsSection.vue'
import StatsSection from './StatsSection.vue'
import AboutSection from './AboutSection.vue'
import WhyUsSection from './WhyUsSection.vue'
import CTASection from './CTASection.vue'

export default {
  name: 'HomePage',
  components: { HeroSection, ProductsSection, StatsSection, AboutSection, WhyUsSection, CTASection },
  metaInfo() {
    const routeMeta = this.$route.meta || {}
    return {
      title: routeMeta.title || 'ELTTEC 易伦特科技 - 智能数字化解决方案',
      meta: [
        { vmid: 'description', name: 'description', content: routeMeta.description || 'ELTTEC 易伦特科技专注企业数字化转型，提供SSMS/EOM/RPA/DAuto四大核心产品线。' },
        { vmid: 'keywords', name: 'keywords', content: routeMeta.keywords || 'ELTTEC,易伦特科技,数字化,自动化,智能制造,船舶服务管理,工业4.0' },
        { vmid: 'og:title', property: 'og:title', content: routeMeta.title || 'ELTTEC 易伦特科技 - 智能数字化解决方案' },
        { vmid: 'og:description', property: 'og:description', content: routeMeta.description || '' },
        { vmid: 'og:url', property: 'og:url', content: 'https://elttec.com/' },
        { vmid: 'og:type', property: 'og:type', content: 'website' },
        { vmid: 'og:image', property: 'og:image', content: 'https://elttec.com/og-image.png' },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        { vmid: 'twitter:title', name: 'twitter:title', content: routeMeta.title || 'ELTTEC 易伦特科技' },
        { vmid: 'twitter:description', name: 'twitter:description', content: routeMeta.description || '' },
        { vmid: 'robots', name: 'robots', content: 'index, follow, max-snippet:-1, max-image-preview:large' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: 'https://elttec.com/' }
      ],
      script: [{
        vmid: 'schema-org',
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          '@id': 'https://elttec.com/#organization',
          name: 'ELTTEC 易伦特科技',
          alternateName: 'ELTTEC',
          description: 'ELTTEC 易伦特科技专注企业数字化转型，提供涵盖船舶服务管理、企业运营管理、机器人流程自动化、数字自动化产线集成的一站式智能解决方案。',
          url: 'https://elttec.com',
          logo: 'https://elttec.com/logo.png',
          sameAs: [],
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'sales',
            telephone: '',
            availableLanguage: ['Chinese', 'English']
          },
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'CN'
          },
          makesOffer: [
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'SoftwareApplication',
                name: 'SSMS 船舶服务管理系统',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web',
                description: 'AI驱动的船舶服务与供应链管理平台，涵盖报价、采购、货物追踪、单船核算全流程数字化管理。'
              }
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'SoftwareApplication',
                name: 'EOM 企业运营管理平台',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web',
                description: '跨系统业务集成与流程自动化平台，打破ERP、CRM、SRM等系统间的信息壁垒。'
              }
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'SoftwareApplication',
                name: 'RPA 机器人流程自动化',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web, Windows',
                description: '通过软件机器人自动执行重复性任务，实现跨系统数据抓取、表单填报、报表生成等流程的端到端自动化。'
              }
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'SoftwareApplication',
                name: 'DAuto 数字自动化产线集成',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web',
                description: '打通数字化管理系统与自动化产线设备，实现设备互联、IT-OT融合、柔性制造与智能优化决策。'
              }
            }
          ]
        }
      }, {
        vmid: 'schema-breadcrumb',
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'ELTTEC 易伦特科技',
              item: 'https://elttec.com/'
            }
          ]
        }
      }]
    }
  },
  mounted() { this.observeReveal() },
  methods: {
    observeReveal() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible') })
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })
      document.querySelectorAll('.reveal').forEach(el => { if (!el.classList.contains('visible')) observer.observe(el) })
    }
  }
}
</script>

<style scoped>
.home-page{overflow-x:hidden}
</style>
